/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app_config = __webpack_require__(1);

__webpack_require__(2);

__webpack_require__(8);

angular.module('sfa-angular-utils', ['components', 'mixpanel']);

angular.module('sfa-angular-utils').config(_app_config.config);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = function config(toastrConfig) {
  toastrConfig.maxOpened = 4;
  toastrConfig.allowHtml = true;
  toastrConfig.positionClass = 'toast-top-right';
  toastrConfig.iconClasses.success = 'toast-success';
  toastrConfig.iconClasses.error = 'toast-warning';
};

config.$inject = ['toastrConfig'];

exports.config = config;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

var _app_drawer = __webpack_require__(5);

var _flash = __webpack_require__(7);

angular.module('components', ['toastr']);

angular.module('components').controller('AppDrawerController', _app_drawer.AppDrawerController).directive('appDrawer', _app_drawer.appDrawerDirective).factory('FlashService', _flash.FlashService);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(4);
module.exports = 'toastr';

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('toastr', []).factory('toastr', toastr);

  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];

  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
    var container;
    var index = 0;
    var toasts = [];

    var previousToastMessage = '';
    var openToasts = {};

    var containerDefer = $q.defer();

    var toast = {
      active: active,
      clear: clear,
      error: error,
      info: info,
      remove: remove,
      success: success,
      warning: warning,
      refreshTimer: refreshTimer
    };

    return toast;

    /* Public API */
    function active() {
      return toasts.length;
    }

    function clear(toast) {
      // Bit of a hack, I will remove this soon with a BC
      if (arguments.length === 1 && !toast) {
        return;
      }

      if (toast) {
        remove(toast.toastId);
      } else {
        for (var i = 0; i < toasts.length; i++) {
          remove(toasts[i].toastId);
        }
      }
    }

    function error(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.error;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function info(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.info;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function success(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.success;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function warning(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.warning;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function refreshTimer(toast, newTime) {
      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
        toast.scope.refreshTimer(newTime);
      }
    }

    function remove(toastId, wasClicked) {
      var toast = findToast(toastId);

      if (toast && !toast.deleting) {
        // Avoid clicking when fading out
        toast.deleting = true;
        toast.isOpened = false;
        $animate.leave(toast.el).then(function () {
          if (toast.scope.options.onHidden) {
            toast.scope.options.onHidden(!!wasClicked, toast);
          }
          toast.scope.$destroy();
          var index = toasts.indexOf(toast);
          delete openToasts[toast.scope.message];
          toasts.splice(index, 1);
          var maxOpened = toastrConfig.maxOpened;
          if (maxOpened && toasts.length >= maxOpened) {
            toasts[maxOpened - 1].open.resolve();
          }
          if (lastToast()) {
            container.remove();
            container = null;
            containerDefer = $q.defer();
          }
        });
      }

      function findToast(toastId) {
        for (var i = 0; i < toasts.length; i++) {
          if (toasts[i].toastId === toastId) {
            return toasts[i];
          }
        }
      }

      function lastToast() {
        return !toasts.length;
      }
    }

    /* Internal functions */
    function _buildNotification(type, message, title, optionsOverride) {
      if (angular.isObject(title)) {
        optionsOverride = title;
        title = null;
      }

      return _notify({
        iconClass: type,
        message: message,
        optionsOverride: optionsOverride,
        title: title
      });
    }

    function _getOptions() {
      return angular.extend({}, toastrConfig);
    }

    function _createOrGetContainer(options) {
      if (container) {
        return containerDefer.promise;
      }

      container = angular.element('<div></div>');
      container.attr('id', options.containerId);
      container.addClass(options.positionClass);
      container.css({ 'pointer-events': 'auto' });

      var target = angular.element(document.querySelector(options.target));

      if (!target || !target.length) {
        throw 'Target for toasts doesn\'t exist';
      }

      $animate.enter(container, target).then(function () {
        containerDefer.resolve();
      });

      return containerDefer.promise;
    }

    function _notify(map) {
      var options = _getOptions();

      if (shouldExit()) {
        return;
      }

      var newToast = createToast();

      toasts.push(newToast);

      if (ifMaxOpenedAndAutoDismiss()) {
        var oldToasts = toasts.slice(0, toasts.length - options.maxOpened);
        for (var i = 0, len = oldToasts.length; i < len; i++) {
          remove(oldToasts[i].toastId);
        }
      }

      if (maxOpenedNotReached()) {
        newToast.open.resolve();
      }

      newToast.open.promise.then(function () {
        _createOrGetContainer(options).then(function () {
          newToast.isOpened = true;
          if (options.newestOnTop) {
            $animate.enter(newToast.el, container).then(function () {
              newToast.scope.init();
            });
          } else {
            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
            $animate.enter(newToast.el, container, sibling).then(function () {
              newToast.scope.init();
            });
          }
        });
      });

      return newToast;

      function ifMaxOpenedAndAutoDismiss() {
        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
      }

      function createScope(toast, map, options) {
        if (options.allowHtml) {
          toast.scope.allowHtml = true;
          toast.scope.title = $sce.trustAsHtml(map.title);
          toast.scope.message = $sce.trustAsHtml(map.message);
        } else {
          toast.scope.title = map.title;
          toast.scope.message = map.message;
        }

        toast.scope.toastType = toast.iconClass;
        toast.scope.toastId = toast.toastId;
        toast.scope.extraData = options.extraData;

        toast.scope.options = {
          extendedTimeOut: options.extendedTimeOut,
          messageClass: options.messageClass,
          onHidden: options.onHidden,
          onShown: generateEvent('onShown'),
          onTap: generateEvent('onTap'),
          progressBar: options.progressBar,
          tapToDismiss: options.tapToDismiss,
          timeOut: options.timeOut,
          titleClass: options.titleClass,
          toastClass: options.toastClass
        };

        if (options.closeButton) {
          toast.scope.options.closeHtml = options.closeHtml;
        }

        function generateEvent(event) {
          if (options[event]) {
            return function () {
              options[event](toast);
            };
          }
        }
      }

      function createToast() {
        var newToast = {
          toastId: index++,
          isOpened: false,
          scope: $rootScope.$new(),
          open: $q.defer()
        };
        newToast.iconClass = map.iconClass;
        if (map.optionsOverride) {
          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
        }

        createScope(newToast, map, options);

        newToast.el = createToastEl(newToast.scope);

        return newToast;

        function cleanOptionsOverride(options) {
          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop', 'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
          for (var i = 0, l = badOptions.length; i < l; i++) {
            delete options[badOptions[i]];
          }

          return options;
        }
      }

      function createToastEl(scope) {
        var angularDomEl = angular.element('<div toast></div>'),
            $compile = $injector.get('$compile');
        return $compile(angularDomEl)(scope);
      }

      function maxOpenedNotReached() {
        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
      }

      function shouldExit() {
        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];

        if (isDuplicateOfLast || isDuplicateOpen) {
          return true;
        }

        previousToastMessage = map.message;
        openToasts[map.message] = true;

        return false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('toastr').constant('toastrConfig', {
    allowHtml: false,
    autoDismiss: false,
    closeButton: false,
    closeHtml: '<button>&times;</button>',
    containerId: 'toast-container',
    extendedTimeOut: 1000,
    iconClasses: {
      error: 'toast-error',
      info: 'toast-info',
      success: 'toast-success',
      warning: 'toast-warning'
    },
    maxOpened: 0,
    messageClass: 'toast-message',
    newestOnTop: true,
    onHidden: null,
    onShown: null,
    onTap: null,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    progressBar: false,
    tapToDismiss: true,
    target: 'body',
    templates: {
      toast: 'directives/toast/toast.html',
      progressbar: 'directives/progressbar/progressbar.html'
    },
    timeOut: 5000,
    titleClass: 'toast-title',
    toastClass: 'toast'
  });
})();

(function () {
  'use strict';

  angular.module('toastr').directive('progressBar', progressBar);

  progressBar.$inject = ['toastrConfig'];

  function progressBar(toastrConfig) {
    return {
      require: '^toast',
      templateUrl: function templateUrl() {
        return toastrConfig.templates.progressbar;
      },
      link: linkFunction
    };

    function linkFunction(scope, element, attrs, toastCtrl) {
      var intervalId, currentTimeOut, hideTime;

      toastCtrl.progressBar = scope;

      scope.start = function (duration) {
        if (intervalId) {
          clearInterval(intervalId);
        }

        currentTimeOut = parseFloat(duration);
        hideTime = new Date().getTime() + currentTimeOut;
        intervalId = setInterval(updateProgress, 10);
      };

      scope.stop = function () {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };

      function updateProgress() {
        var percentage = (hideTime - new Date().getTime()) / currentTimeOut * 100;
        element.css('width', percentage + '%');
      }

      scope.$on('$destroy', function () {
        // Failsafe stop
        clearInterval(intervalId);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('toastr').controller('ToastController', ToastController);

  function ToastController() {
    this.progressBar = null;

    this.startProgressBar = function (duration) {
      if (this.progressBar) {
        this.progressBar.start(duration);
      }
    };

    this.stopProgressBar = function () {
      if (this.progressBar) {
        this.progressBar.stop();
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('toastr').directive('toast', toast);

  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];

  function toast($injector, $interval, toastrConfig, toastr) {
    return {
      templateUrl: function templateUrl() {
        return toastrConfig.templates.toast;
      },
      controller: 'ToastController',
      link: toastLinkFunction
    };

    function toastLinkFunction(scope, element, attrs, toastCtrl) {
      var timeout;

      scope.toastClass = scope.options.toastClass;
      scope.titleClass = scope.options.titleClass;
      scope.messageClass = scope.options.messageClass;
      scope.progressBar = scope.options.progressBar;

      if (wantsCloseButton()) {
        var button = angular.element(scope.options.closeHtml),
            $compile = $injector.get('$compile');
        button.addClass('toast-close-button');
        button.attr('ng-click', 'close(true, $event)');
        $compile(button)(scope);
        element.children().prepend(button);
      }

      scope.init = function () {
        if (scope.options.timeOut) {
          timeout = createTimeout(scope.options.timeOut);
        }
        if (scope.options.onShown) {
          scope.options.onShown();
        }
      };

      element.on('mouseenter', function () {
        hideAndStopProgressBar();
        if (timeout) {
          $interval.cancel(timeout);
        }
      });

      scope.tapToast = function () {
        if (angular.isFunction(scope.options.onTap)) {
          scope.options.onTap();
        }
        if (scope.options.tapToDismiss) {
          scope.close(true);
        }
      };

      scope.close = function (wasClicked, $event) {
        if ($event && angular.isFunction($event.stopPropagation)) {
          $event.stopPropagation();
        }
        toastr.remove(scope.toastId, wasClicked);
      };

      scope.refreshTimer = function (newTime) {
        if (timeout) {
          $interval.cancel(timeout);
          timeout = createTimeout(newTime || scope.options.timeOut);
        }
      };

      element.on('mouseleave', function () {
        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) {
          return;
        }
        scope.$apply(function () {
          scope.progressBar = scope.options.progressBar;
        });
        timeout = createTimeout(scope.options.extendedTimeOut);
      });

      function createTimeout(time) {
        toastCtrl.startProgressBar(time);
        return $interval(function () {
          toastCtrl.stopProgressBar();
          toastr.remove(scope.toastId);
        }, time, 1);
      }

      function hideAndStopProgressBar() {
        scope.progressBar = false;
        toastCtrl.stopProgressBar();
      }

      function wantsCloseButton() {
        return scope.options.closeHtml;
      }
    }
  }
})();

angular.module("toastr").run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/progressbar/progressbar.html", "<div class=\"toast-progress\"></div>\n");
  $templateCache.put("directives/toast/toast.html", "<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");
}]);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AppDrawerController = function AppDrawerController($http) {
  var vm = this;
  vm.apps = [];

  function init() {
    $http({
      method: 'GET',
      url: 'https://sfa.sharethrough.com/api/v1/apps',
      headers: {
        'api-key': '5b771af9f1a90722640e667d8634aef8'
      }
    }).then(function (response) {
      vm.apps = response.data;
    }, function () {
      console.log('Error loading app drawer!');
    });
  }

  init();

  return vm;
};

AppDrawerController.$inject = ['$http'];

var appDrawerDirective = function appDrawerDirective() {
  return {
    controllerAs: 'AppDrawerCtrl',
    controller: 'AppDrawerController',
    bindToController: true,
    template: __webpack_require__(6)
  };
};

exports.AppDrawerController = AppDrawerController;
exports.appDrawerDirective = appDrawerDirective;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "<div class=\"txt-white\">\n  <md-icon class=\"material-icons app-drawer-icon clickable\" ng-click=\"appDrawerOpen = !appDrawerOpen\">apps</md-icon>\n</div>\n<div class=\"app-drawer-container mt1\" ng-show=\"appDrawerOpen\">\n  <div class=\"app-drawer\">\n    <div class=\"row\">\n      <div class=\"col-md-4 mb1\" ng-repeat=\"app in AppDrawerCtrl.apps\">\n        <a ng-href=\"{{app.link}}\" target=\"_blank\">\n          <div class=\"card\">\n            <div class=\"card-content\">\n              <div class=\"circle\" ng-class=\"{ '{{app.iconColor}}': true }\">\n                <md-icon class=\"material-icons\" ng-if=\"app.icon\" ng-bind=\"app.icon\"></md-icon>\n                <svg ng-style=\"app.svgStyles\" ng-if=\"app.svg\" width=\"26px\" height=\"30px\" viewBox=\"0 0 26 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                  <g id=\"WF\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                    <g id=\"Artboard\" fill=\"#ffffff\">\n                      <path id=\"Fill-1\" ng-attr-d=\"{{app.svg}}\"></path>\n                    </g>\n                  </g>\n                </svg>\n              </div>\n              <h5 ng-bind=\"app.name\"></h5>\n            </div>\n          </div>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FlashService = function FlashService(toastr) {
  var SUCCESS_TIMEOUT = 3500;
  var ERROR_TIMEOUT = 10000;

  return {
    push: push,
    toastr: toastr
  };

  function push(type, message) {
    if (type === 'success') {
      return toastr.success(message, {
        timeOut: SUCCESS_TIMEOUT
      });
    } else if (type === 'error') {
      return toastr.error(message, {
        timeOut: ERROR_TIMEOUT
      });
    }
  }
};

FlashService.$inject = ['toastr'];

exports.FlashService = FlashService;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mixpanel_click = __webpack_require__(9);

var _mixpanel_link = __webpack_require__(10);

var _mixpanel = __webpack_require__(11);

var _session_information = __webpack_require__(12);

angular.module('mixpanel', []);

angular.module('mixpanel').factory('MixpanelService', _mixpanel.MixpanelService).factory('SessionInformationService', _session_information.SessionInformationService).controller('MixpanelClickController', _mixpanel_click.MixpanelClickController).controller('MixpanelLinkController', _mixpanel_link.MixpanelLinkController).directive('mixpanelClick', _mixpanel_click.mixpanelClickDirective).directive('mixpanelLink', _mixpanel_link.mixpanelLinkDirective);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MixpanelClickController = function MixpanelClickController(MixpanelService) {
  var vm = this;

  vm.event = '';
  vm.customProperties = {};

  vm.handleClick = function handleClick() {
    MixpanelService.track(vm.event, vm.customProperties);
  };

  return vm;
};

MixpanelClickController.$inject = ['MixpanelService'];

var mixpanelClickDirective = function mixpanelClickDirective() {
  return {
    restrict: 'A',
    controller: MixpanelClickController,
    controllerAs: 'vm',
    bindToController: true,
    link: function link(scope, element, attrs, controller) {
      controller.event = attrs.mixpanelClick;
      if (attrs.mixpanelProperties && attrs.mixpanelProperties.length > 0) {
        controller.customProperties = JSON.parse(attrs.mixpanelProperties);
      }
      element.bind('click', controller.handleClick);
    }
  };
};

exports.MixpanelClickController = MixpanelClickController;
exports.mixpanelClickDirective = mixpanelClickDirective;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MixpanelLinkController = function MixpanelLinkController(MixpanelService, $window) {
  var vm = this;

  vm.trackAndGoToUrl = trackAndGoToUrl;

  function trackAndGoToUrl() {
    if (vm.properties && vm.properties.length > 0) {
      vm.properties = JSON.parse(vm.properties);
    }

    MixpanelService.track(vm.event, vm.properties).then(function () {
      $window.location.href = vm.href;
    });
  }

  return vm;
};

MixpanelLinkController.$inject = ['MixpanelService', '$window'];

var mixpanelLinkDirective = function mixpanelLinkDirective() {
  return {
    template: '<a ng-click="vm.trackAndGoToUrl()"><span ng-transclude></span></a>',
    controller: MixpanelLinkController,
    controllerAs: 'vm',
    bindToController: true,
    transclude: true,
    restrict: 'E',
    replace: true,
    scope: {
      event: '@',
      href: '@',
      properties: '@'
    }
  };
};

exports.MixpanelLinkController = MixpanelLinkController;
exports.mixpanelLinkDirective = mixpanelLinkDirective;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MixpanelService = function MixpanelService(SessionInformationService) {
  return {
    track: track,
    trackBooleanSelection: trackBooleanSelection,
    trackFilterSelection: trackFilterSelection
  };

  function setSessionInformation() {
    return SessionInformationService.getSessionInfo().then(function (info) {
      var user = info.user;
      var partner = info.partner;
      var ipAddress = info.ipAddress;

      if (!info.user.guest) {
        mixpanel.identify(info.user.id);

        mixpanel.people.set({
          $email: user.email,
          $first_name: user.firstName,
          $last_name: user.lastName
        });
      }

      return {
        user: user,
        partner: partner,
        ipAddress: ipAddress
      };
    });
  }

  function track(evt, attrs) {
    var customProperties = attrs || {};
    return setSessionInformation().then(function (info) {
      customProperties.ipAddress = info.ipAddress;

      if (info.partner) {
        customProperties.partner = info.partner.name;
        customProperties.partnerType = info.partner.partnerType;
      }
      mixpanel.track(evt, customProperties);
    }).catch(function (err) {
      console.log(err);
    });
  }

  function trackBooleanSelection(val, name, attrs) {
    var state = val === true ? 'Enabled' : 'Disabled';
    // ex: Sports Category Filter Enabled
    return track(name + ' ' + state, attrs).catch(function () {
      return;
    });
  }

  function trackFilterSelection(filter, filterType, attrs) {
    //ex: Sports Category Filter
    var eventName = filter.name + ' ' + filterType + ' Filter';
    return trackBooleanSelection(filter.selected, eventName, attrs);
  }
};

MixpanelService.$inject = ['SessionInformationService'];

exports.MixpanelService = MixpanelService;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SessionInformationService = function SessionInformationService($http, $location) {
  var user = null;

  return {
    getSessionInfo: getSessionInfo
  };

  function getSessionInfo() {
    return get().then(function (response) {
      return response.data;
    });
  }

  function get() {
    var url = '/api/internal/session_info';
    var partnerQueryParam = $location.search().subdomain;
    if (partnerQueryParam) {
      url += '?subdomain=' + partnerQueryParam;
    }

    return $http.get(url);
  }
};

SessionInformationService.$inject = ['$http', '$location'];

exports.SessionInformationService = SessionInformationService;

/***/ })
/******/ ]);